// @ts-nocheck

import { match as MatchStateUtils } from '..';
import { __ } from '../../i18n/l10n';
import type { ScoreboardProps, SecondariesScoreType, ScorersType } from '../../states/scoreboards';
import { getExtendedMinuteStringFromMatchTime } from '../date';

export const computeScorers = (scorers: Array<unknown> = [], side: string): ScorersType =>
  scorers.reduce((acc, scorer) => {
    const { scoringTeam, time, player, type } = scorer;

    if (scoringTeam === side && time !== undefined && time !== null && time !== -1) {
      const formattedTime = getExtendedMinuteStringFromMatchTime(time);

      return [
        ...acc,
        {
          player: player ?? '',
          time: formattedTime,
          type: type,
        },
      ];
    }
    return acc;
  }, []);

export const computeSecondaryScores = (scores: Array<string>): SecondariesScoreType => {
  const finalScores = [];

  // Same TAB gestion as handball and same OT gestion as soccer
  if (scores.length > 1) {
    finalScores.unshift({
      label: __('!short:HalfTime'),
      score: scores[0].split(':'),
    });
  }
  if (scores.length > 2) {
    finalScores.unshift({
      label: __('!short:RegularTime'),
      score: [MatchStateUtils.computeScore(scores, 0, 2), MatchStateUtils.computeScore(scores, 1, 2)],
    });
  }

  return finalScores;
};

export default ({
  sportId,
  matchId,
  period,
  periodName,
  setScores,
  competitor1Name,
  competitor1Flag,
  yellowRedCardsHome = 0,
  redCardsHome = 0,
  competitor2Name,
  competitor2Flag,
  yellowRedCardsAway = 0,
  redCardsAway = 0,
  scorers,
}: unknown): ScoreboardProps => {
  let scores = null;

  if (setScores && setScores !== '') {
    scores = setScores.split(' - ');
  }

  return {
    matchId,
    period: periodName || MatchStateUtils.statusMatchBySport(sportId, period),
    competitors: [
      {
        name: competitor1Name,
        flag: competitor1Flag,
        nbRedCards: yellowRedCardsHome + redCardsHome,
        scorers: computeScorers(scorers, 'home'),
      },
      {
        name: competitor2Name,
        flag: competitor2Flag,
        nbRedCards: yellowRedCardsAway + redCardsAway,
        scorers: computeScorers(scorers, 'away'),
      },
    ],
    scores: {
      main: {
        score: scores
          ? [MatchStateUtils.computeScore(scores, 0, 4), MatchStateUtils.computeScore(scores, 1, 4)]
          : ['', ''],
        isActive: scores ? scores.length < 5 : false,
      },
      secondaries: scores ? computeSecondaryScores(scores) : [],
    },
    expandThreshold: 5,
  };
};
